import React, { Component } from 'react';

class OtherPOICharacteristicsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cost: 3,
      familiarity: 1,
      walking: 3,
      pace: 3,
      accessible: false,
    };

    this.costInfo = [
      0,
      "I wish to avoid all paid attractions",
      "I would like to avoid paid attractions, except especially relevant ones",
      "I am willing to pay for attractions with a high cost-benefit tradeoff",
      "I only wish to avoid excessively expensive attractions",
      "Cost should not be considered when choosing attractions to visit",
    ];

    this.familiarityInfo = [
      0,
      "This is the first time I visit this city",
      "I've visited this city before but don't remember much",
      "I have visited this city in the past and seen most of the major sights",
      "I have visited this city frequently and am quite familiar with its sights",
      "I am a local",
    ];

    this.walkingInfo = [
      0,
      "I have mobility issues and wish to walk as little as possible",
      "I am not fond of walking and would like to mostly avoid it",
      "I am willing to walk but not excessively",
      "I am fond of walking and want to discover the city primarily on foot",
      "I would like to discover the city almost entirely on foot",
    ];

    this.paceInfo = [
      0,
      "I want to visit as many attractions as possible, as quickly as possible",
      "I prefer spending less time at attractions to visit more attractions",
      "I want a balance between time at attractions and number of attractions",
      "I prefer visiting fewer attractions, spending a longer time at each",
      "I want to visit only a select few attractions spending a lot of time at each",
    ];

    this.accessibleInfo = ["", "Only wheelchair-accessible attractions should be considered"];
  }

  handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    this.setState({ [name]: type === 'checkbox' ? checked : value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { cost, familiarity, walking, pace, accessible } = this.state;
    const newData = {
      ...this.props.formData,
      user_cost: cost,
      user_popularity: 6 - familiarity,
      user_accessibility: accessible,
      walking,
      pace,
    };
    this.props.onNavigate(newData);
  };

  render() {
    const { cost, familiarity, walking, pace, accessible } = this.state;

    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <header className="form-header">
            <h1>Other attraction preferences</h1>
          </header>
          <div className="form-container">
            <div className="input-Trip">
              <label className="date-label">Cost:</label>
              <input
                type="range"
                className="slider"
                name="cost"
                min="1"
                max="5"
                value={cost}
                onChange={this.handleChange}
              />
              <span className="slider-info">{this.costInfo[cost]}</span>
            </div>
            <div className="input-Trip">
              <label className="date-label">City familiarity:</label>
              <input
                type="range"
                className="slider"
                name="familiarity"
                min="1"
                max="5"
                value={familiarity}
                onChange={this.handleChange}
              />
              <span className="slider-info">{this.familiarityInfo[familiarity]}</span>
            </div>
            <div className="input-Trip">
              <label className="date-label">Walking preference:</label>
              <input
                type="range"
                className="slider"
                name="walking"
                min="1"
                max="5"
                value={walking}
                onChange={this.handleChange}
              />
              <span className="slider-info">{this.walkingInfo[walking]}</span>
            </div>
            <div className="input-Trip">
              <label className="date-label">Visit pace:</label>
              <input
                type="range"
                className="slider"
                name="pace"
                min="1"
                max="5"
                value={pace}
                onChange={this.handleChange}
              />
              <span className="slider-info">{this.paceInfo[pace]}</span>
            </div>
            <div className="input-Accessibility">
              <label className="date-label">Accessibility:</label>
              <input
                type="checkbox"
                className="accessible-checkbox"
                name="accessible"
                checked={accessible}
                onChange={this.handleChange}
              />
              <label className="accessible-label">{this.accessibleInfo[accessible ? 1 : 0]}</label>
            </div>
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    );
  }
}

export default OtherPOICharacteristicsForm;
